import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "rounded-lg bgColor file-list"
};
const _hoisted_2 = {
  class: "flex justify-between pl-4 pr-4"
};
const _hoisted_3 = {
  class: "flex items-center gap-3"
};
const _hoisted_4 = {
  key: 0,
  class: "absolute -top-1 -left-1"
};
const _hoisted_5 = {
  class: "fileItem"
};
const _hoisted_6 = {
  class: "title truncate"
};
const _hoisted_7 = {
  class: "desc"
};
const _hoisted_8 = {
  class: "media-list flex flex-wrap gap-2"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  class: "rounded-lg bgColor text-[#86909C] p-4 mt-3"
};
const _hoisted_12 = {
  class: "text-[#1D2129]"
};
import { ref, onMounted, computed, inject } from 'vue';
import BatchBannedWordCheck from './BatchBannedWordCheck.vue';
import useAppStore from '@views/app.store';
import DraggableWrapper from '@views/home/components/preview-dialog/DraggableWrapper.vue';
import Tab3Dialog from './Tab3Dialog.vue';
import ArticleHandle from '../components/ArticleHandle.vue';
export default /*@__PURE__*/Object.assign({
  name: 'MediaCreateTab3'
}, {
  __name: 'Tab3',
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['refresh'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const appStore = useAppStore();
    const useCount = computed(() => {
      const list = availableFiles.value.filter(file => {
        return file.newsSource;
      });
      return list.length * 10;
    });
    const availableFiles = inject('availableFiles');
    const tab3DialogRef = ref();
    const clickBatchSetting = () => {
      tab3DialogRef.value.openDialog();
    };
    const clickEdit = file => {
      tab3DialogRef.value.openDialog(file);
    };
    const clickNo = file => {
      file.newsAuthor = null;
      file.newsSource = null;
      file.newsKeywords = null;
    };
    const handleSure = (data, file) => {
      if (file) {
        file.newsAuthor = data.Author;
        file.newsSource = data.Source;
        file.newsKeywords = data.SeoKeywordList;
      } else {
        availableFiles.value.forEach(item => {
          item.newsAuthor = data.Author;
          item.newsSource = data.Source;
          item.newsKeywords = data.SeoKeywordList;
        });
      }
    };
    const handleRenderData = data => {
      return {
        type: 'card',
        title: data.title,
        content: data.content
      };
    };
    onMounted(() => {});
    __expose({
      useCount
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      return _openBlock(), _createElementBlock("div", null, [_cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "alert-hint mb-3"
      }, [_createElementVNode("div", null, "1、根据联盟新闻平台的要求，以下内容均不能填写链接地址;"), _createElementVNode("div", null, " 2、我们将在1-3个工作日内完成审核，如审核未通过或发布未成功，已扣除的条数将返回至您的账户中。 ")], -1)), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "flex items-center gap-2"
      }, [_createElementVNode("div", {
        class: "text-[#1D2129] font-medium"
      }, "设置发布媒体"), _createElementVNode("div", {
        class: "text-[#86909C]"
      }, "单平台发布消耗10点权益")], -1)), _createElementVNode("div", _hoisted_3, [_createVNode(BatchBannedWordCheck), _createVNode(_component_el_button, {
        link: "",
        type: "primary",
        onClick: clickBatchSetting
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode(" 批量设置媒体 ", -1)]))]),
        _: 1
      })])]), _createVNode(_component_el_row, {
        class: "pl-4 pr-4 pb-4",
        gutter: 12
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableFiles), (file, index) => {
          return _openBlock(), _createBlock(_component_el_col, {
            class: "mt-2 relative",
            key: index,
            span: 8
          }, {
            default: _withCtx(() => [file.bannedWords ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(ArticleHandle, {
              data: file,
              onRefresh: _cache[0] || (_cache[0] = $event => emits('refresh'))
            }, null, 8, ["data"])])) : _createCommentVNode("", true), _createVNode(DraggableWrapper, {
              renderData: handleRenderData(file)
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createTextVNode(_toDisplayString(file.fileTitle) + " ", 1), _createElementVNode("div", _hoisted_7, _toDisplayString(file.newsSource ? '本次发布1个平台，预计10点' : ' '), 1)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("span", {
                class: _normalizeClass(["media-item", {
                  'is-active': file.newsSource
                }]),
                onClick: $event => clickEdit(file)
              }, " 发联盟新闻 ", 10, _hoisted_9), _createElementVNode("span", {
                class: _normalizeClass(["media-item", {
                  'is-active': !file.newsSource
                }]),
                onClick: $event => clickNo(file)
              }, " 不发联盟新闻 ", 10, _hoisted_10)])])]),
              _: 2
            }, 1032, ["renderData"])]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      })]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_12, "预计消耗权益点：" + _toDisplayString(useCount.value) + "点", 1), _createTextVNode(" （当前可用点数：" + _toDisplayString(_unref(appStore).surplusNum) + "点） ", 1)])]), _createVNode(Tab3Dialog, {
        ref_key: "tab3DialogRef",
        ref: tab3DialogRef,
        onClickSure: handleSure
      }, null, 512)]);
    };
  }
});